/*
  Normal SBC solutions, every pool at once: what `POST /sbcs/:id/solutions`
  sends. Mirrors `FeSbcSolutions` in peareasy-services
  (`src/sbcs/types/api-contracts/sbc-solutions.ts`). Tags and flags only, no
  display strings (ADR 0024): a tag's title and explanation are i18n keys under
  `sbcs:solutions.tags.<tag>`, composed at the render site.
*/
/** The order the backend lists the pools in, and the order the list shows them. */
export const SBC_SOLUTION_TAGS = ["club", "both", "market"];
//# sourceMappingURL=sbcSolutions.js.map